import { UcoastEl } from '@/scripts/core/UcoastEl';
import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import {TsDOM as q} from '@/scripts/core/TsDOM'
import { type ModalDialog } from '@/scripts/interactive-defer/modal-dialog'

export class MediaGallery extends UcoastEl {
	static htmlSelector = 'media-gallery'
	loadedAll: boolean
	currentSlideStatus: HTMLElement
	prevButton: HTMLButtonElement
	nextButton: HTMLButtonElement
	openDialogButton: HTMLButtonElement
	dialog: ModalDialog
	mediaModalItems: NodeListOf<HTMLElement>
	private expandButton: HTMLElement;
	private gallery: HTMLElement;
	private scrollThreshold: number;
	private isMobile: boolean;

	constructor() {
		super()
		this.loadedAll = false
		this.currentSlideStatus = q.rs('[data-current-slide]', this)
		this.updateCounter = this.updateCounter.bind(this)
		this.prevButton = q.rs('[data-prev-button]', this)
		this.nextButton = q.rs('[data-next-button]', this)
		this.openDialogButton = q.rs('[data-dialog-button]', this)
		this.dialog = q.rs('#PopupModal-media')
		this.mediaModalItems = q.rl('[data-media-modal-item]')
		const OPTIONS: EmblaOptionsType = {
			slidesToScroll: 1,
			align: 'start',
			containScroll: 'trimSnaps',
			dragFree: false,
			dragThreshold: 1,
			duration: 20,
		}

		const viewportNode = q.rs('[data-embla-viewport]', this)
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
		])
		this.prevButton.addEventListener('click', () => emblaApi.scrollPrev())
		this.nextButton.addEventListener('click', () => emblaApi.scrollNext())
		this.openDialogButton.addEventListener('click', () => {
			this.dialog.show(this.openDialogButton)
			this.mediaModalItems.forEach((item, index) => {
				if (index === emblaApi.selectedScrollSnap()) {
					item.scrollIntoView({ behavior: 'smooth', block: 'start' })
				}
			})
			void window.Ucoast.mediaManager.playAllInContainer(this.dialog)
		})
		emblaApi.on('select', (emblaApi, _) => {
			this.updateCounter(emblaApi.selectedScrollSnap())
			this.updateButtonVisibility(emblaApi.selectedScrollSnap(), emblaApi.slideNodes().length)
		})

		this.expandButton = this.openDialogButton;
		this.gallery = this;
		this.isMobile = window.innerWidth < 768;
		this.scrollThreshold = 0;
		this.initializeEventListeners();
		this.initializeScrollBehavior();
	}

	updateCounter(index: number) {
		this.currentSlideStatus.textContent = `${index + 1}`
		// todo select media item to play
	}

	updateButtonVisibility(index: number, totalSlides: number) {
		this.prevButton.disabled = index === 0
		this.nextButton.disabled = index === totalSlides - 1
	}

	private initializeEventListeners(): void {
		window.addEventListener('scroll', this.handleScroll.bind(this));
		window.addEventListener('resize', this.handleResize.bind(this));
	}

	private initializeScrollBehavior(): void {
		this.scrollThreshold = this.calculateScrollThreshold();
		this.handleScroll();
	}

	private handleResize(): void {
		this.isMobile = window.innerWidth < 768;
		if (!this.isMobile) {
			this.initializeScrollBehavior();
		} else {
			this.expandButton.classList.remove('not-in-gallery');
		}
	}

	private calculateScrollThreshold(): number {
		const galleryRect = this.gallery.getBoundingClientRect();
		const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
		return galleryRect.top + galleryRect.height + currentScrollPosition - window.innerHeight;
	}

	private handleScroll(): void {
		if (this.isMobile) return;

		const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollPosition > this.scrollThreshold) {
			this.expandButton.classList.add('not-in-gallery');
		} else {
			this.expandButton.classList.remove('not-in-gallery');
		}
	}
}
